import { i18n } from "src/boot/i18n"
import { MissingEntityType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { MissingEntityDefinition } from "src/util/types/dataModels/entityDefinition"

export const EmptyStates = new Map<MissingEntityType, MissingEntityDefinition>()

const { t } = i18n.global

EmptyStates.set(MissingEntityType.AREA_NOT_FOUND, {
  entityName: t("entity.area"),
  icon: Icons.AREA_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.area") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.area") }),
  quote: t("sfxEmpty.quote_area_not_found"),
})

EmptyStates.set(MissingEntityType.AREA_NO_MATCHES, {
  entityName: t("entity.area"),
  icon: Icons.AREA_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.area") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_area_no_matches"),
})

EmptyStates.set(MissingEntityType.ATTACHMENT_DRAG_AND_DROP_ITEM, {
  entityName: t("entity.item"),
  icon: Icons.ATTACHMENTS,
  title: t("sfxEmpty.title_attachment_drag_and_drop", { entity: t("entity.item") }),
  subtitle: t("sfxEmpty.subtitle_attachment_drag_and_drop"),
  quote: t("sfxEmpty.quote_attachment_drag_and_drop"),
})

EmptyStates.set(MissingEntityType.ATTACHMENT_DRAG_AND_DROP_WORK_ORDER, {
  entityName: t("entity.work_order"),
  icon: Icons.ATTACHMENTS,
  title: t("sfxEmpty.title_attachment_drag_and_drop", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_attachment_drag_and_drop"),
  quote: t("sfxEmpty.quote_attachment_drag_and_drop"),
})

EmptyStates.set(MissingEntityType.ATTACHMENT_NOT_FOUND, {
  entityName: t("entity.attachment"),
  icon: Icons.ATTACHMENT_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.attachment") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.attachment") }),
  quote: t("sfxEmpty.quote_attachment_not_found"),
})

EmptyStates.set(MissingEntityType.ATTACHMENT_NO_MATCHES, {
  entityName: t("entity.attachment"),
  icon: Icons.ATTACHMENT_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.attachment") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_attachment_no_matches"),
})

EmptyStates.set(MissingEntityType.ATTACHMENT_NOT_ADDED, {
  entityName: t("entity.attachment"),
  icon: Icons.ATTACHMENT_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.attachment") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_added", { entity: t("entity.attachment") }),
  quote: t("sfxEmpty.quote_attachment_not_added"),
})

EmptyStates.set(MissingEntityType.ITEM_NOT_FOUND, {
  entityName: t("entity.item"),
  icon: Icons.ITEM_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.item") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.item") }),
  quote: t("sfxEmpty.quote_item_not_found"),
})

EmptyStates.set(MissingEntityType.ITEM_NO_MATCHES, {
  entityName: t("entity.item"),
  icon: Icons.ITEM_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.item") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_item_no_matches"),
})

EmptyStates.set(MissingEntityType.ITEM_NO_RELATED_ACTIONS, {
  entityName: t("entity.item"),
  title: t("sfxEmpty.title_no_related_actions"),
  subtitle: t("sfxEmpty.subtitle_no_related_actions"),
  quote: t("sfxEmpty.quote_no_related_actions"),
})

EmptyStates.set(MissingEntityType.ISSUE_NOT_FOUND, {
  entityName: t("entity.issue"),
  icon: Icons.ISSUE_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.issue") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found_exclamation", { entity: t("entity.issue") }),
  quote: t("sfxEmpty.quote_issue_not_found"),
})

EmptyStates.set(MissingEntityType.ISSUE_NO_MATCHES, {
  entityName: t("entity.issue"),
  icon: Icons.ISSUE_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.issue") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_issue_no_matches"),
})

EmptyStates.set(MissingEntityType.LAYOUT_NOT_FOUND, {
  entityName: t("entity.layout"),
  icon: Icons.LAYOUT_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.layout") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.layout") }),
  quote: t("sfxEmpty.quote_layout_not_found"),
})

EmptyStates.set(MissingEntityType.LAYOUT_NO_MATCHES, {
  entityName: t("entity.layout"),
  icon: Icons.LAYOUT_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.layout") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_layout_no_matches"),
})

EmptyStates.set(MissingEntityType.LOCATION_NOT_FOUND, {
  entityName: t("entity.location"),
  icon: Icons.NO_LOCATIONS,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.location") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.location") }),
  quote: t("sfxEmpty.quote_location_not_found"),
})

EmptyStates.set(MissingEntityType.LOCATION_NO_MATCHES, {
  entityName: t("entity.location"),
  icon: Icons.NO_LOCATIONS,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.location") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_location_no_matches"),
})

EmptyStates.set(MissingEntityType.MODEL_NOT_FOUND, {
  entityName: t("entity.model"),
  icon: Icons.MODEL_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.model") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.model") }),
  quote: t("sfxEmpty.quote_model_not_found"),
})

EmptyStates.set(MissingEntityType.MODEL_NO_MATCHES, {
  entityName: t("entity.model"),
  icon: Icons.MODEL_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.model") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_model_no_matches"),
})

EmptyStates.set(MissingEntityType.NOTIFICATION_NOT_FOUND, {
  entityName: t("entity.notification"),
  icon: Icons.NOTIFICATIONS,
  title: t("sfxEmpty.title_notifications_not_found"),
  subtitle: t("sfxEmpty.subtitle_notifications_not_found"),
  quote: t("sfxEmpty.quote_notification_not_found"),
})

EmptyStates.set(MissingEntityType.NO_ATTRIBUTES, {
  entityName: t("entity.attributes"),
  title: t("sfxEmpty.title_no_attributes"),
  subtitle: t("sfxEmpty.subtitle_no_attributes"),
  quote: t("sfxEmpty.quote_attributes"),
})

EmptyStates.set(MissingEntityType.NO_ISSUE_COMMENTS, {
  entityName: t("entity.issue"),
  title: t("sfxEmpty.title_no_comments"),
  subtitle: t("sfxEmpty.subtitle_no_comments", { entity: t("entity.issue") }),
  quote: t("sfxEmpty.quote_no_comments"),
})

EmptyStates.set(MissingEntityType.NO_PERFORMED_WORK_COMMENTS, {
  entityName: t("entity.performed_work"),
  title: t("sfxEmpty.title_no_comments"),
  subtitle: t("sfxEmpty.subtitle_no_comments", { entity: t("entity.performed_work") }),
  quote: t("sfxEmpty.quote_no_comments"),
})

EmptyStates.set(MissingEntityType.NO_WORK_ORDER_COMMENTS, {
  entityName: t("entity.work_order"),
  title: t("sfxEmpty.title_no_comments"),
  subtitle: t("sfxEmpty.subtitle_no_comments", { entity: t("entity.work_order") }),
  quote: t("sfxEmpty.quote_no_comments"),
})

EmptyStates.set(MissingEntityType.PERFORMED_WORK_NOT_FOUND, {
  entityName: t("entity.performed_work"),
  icon: Icons.PERFORMED_WORK_LIST_SLASH,
  title: t("sfxEmpty.title_no_entity", { entity: t("entity.performed_work") }),
  subtitle: t("sfxEmpty.subtitle_performed_work"),
  quote: t("sfxEmpty.quote_performed_work_not_found"),
})

EmptyStates.set(MissingEntityType.PERFORMED_WORK_NO_MATCHES, {
  entityName: t("entity.performed_work"),
  icon: Icons.PERFORMED_WORK_LIST_SLASH,
  title: t("sfxEmpty.title_entity_no_matches_found"),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_performed_work_no_matches"),
})

EmptyStates.set(MissingEntityType.PHOTO_NOT_FOUND, {
  entityName: t("entity.photo"),
  icon: Icons.NO_PHOTOS,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.photo") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.photo") }),
})

EmptyStates.set(MissingEntityType.TODO_NOT_FOUND, {
  entityName: t("entity.to_do"),
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.to_do") }),
  subtitle: t("sfxEmpty.subtitle_to_do", { entity: t("entity.to_do") }),
  quote: t("sfxEmpty.quote_to_do_not_found"),
})

EmptyStates.set(MissingEntityType.UNSUBMITTED_WORK_NOT_FOUND, {
  entityName: t("entity.unsubmitted_work"),
  title: t("sfxEmpty.title_unsubmitted_work_not_found"),
  subtitle: t("sfxEmpty.subtitle_unsubmitted_work_not_found"),
  quote: t("sfxEmpty.quote_unsubmitted_work_not_found"),
})

EmptyStates.set(MissingEntityType.UNSUBMITTED_WORK_NO_MATCHES, {
  entityName: t("entity.unsubmitted_work"),
  title: t("sfxEmpty.title_unsubmitted_work_no_matches", { entity: t("entity.unsubmitted_work") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_unsubmitted_work_not_found"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NOT_ASSIGNED, {
  entityName: t("entity.work_order"),
  icon: Icons.WORKORDER_SLASH,
  title: t("sfxEmpty.title_entity_not_assigned", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_assigned", { entity: t("entity.work_order") }),
  quote: t("sfxEmpty.quote_work_order_not_assigned"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NOT_CREATED, {
  entityName: t("entity.work_order"),
  title: t("sfxEmpty.title_entity_not_created", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_work_order_not_created"),
  quote: t("sfxEmpty.quote_work_order_not_created"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NOT_FOUND, {
  entityName: t("entity.work_order"),
  icon: Icons.WORKORDER_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.work_order") }),
  quote: t("sfxEmpty.quote_work_order_not_found"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NO_MATCHES, {
  entityName: t("entity.work_order"),
  icon: Icons.WORKORDER_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_work_order_no_matches"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NO_SUITABLE_MATCHES, {
  entityName: t("entity.work_order"),
  icon: Icons.WORKORDER_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_no_suitable_work_orders"),
  quote: t("sfxEmpty.quote_work_order_no_matches"),
})

EmptyStates.set(MissingEntityType.WORK_ORDER_NOT_OPEN, {
  entityName: t("entity.work_order"),
  icon: Icons.WORKORDER_SLASH,
  title: t("sfxEmpty.title_entity_not_open", { entity: t("entity.work_order") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_open", { entity: t("entity.work_order") }),
  quote: t("sfxEmpty.quote_work_order_not_open"),
})

EmptyStates.set(MissingEntityType.NO_WORK_ISSUES, {
  entityName: t("entity.work_order"),
  title: t("sfxEmpty.title_no_work_issues"),
  subtitle: t("sfxEmpty.subtitle_no_work_issues"),
})

EmptyStates.set(MissingEntityType.NO_WORK_ITEMS, {
  entityName: t("entity.work_order"),
  title: t("sfxEmpty.title_no_work_items"),
  subtitle: t("sfxEmpty.subtitle_no_work_items"),
})

EmptyStates.set(MissingEntityType.WORKSPACE_NOT_FOUND, {
  entityName: t("entity.workspace"),
  icon: Icons.WORKSPACES,
  title: t("sfxEmpty.title_workspaces_not_found"),
  subtitle: t("sfxEmpty.subtitle_workspace_not_found"),
  quote: t("sfxEmpty.quote_workspace_not_found"),
})

EmptyStates.set(MissingEntityType.WORKSPACE_NOT_FOUND_HOME, {
  entityName: t("entity.workspace"),
  icon: Icons.WORKSPACES,
  title: t("sfxEmpty.title_workspace_not_found"),
  subtitle: t("sfxEmpty.subtitle_workspace_not_found"),
  quote: t("sfxEmpty.quote_workspace_not_found"),
})

EmptyStates.set(MissingEntityType.WORKSPACE_NO_MATCHES, {
  entityName: t("entity.workspace"),
  icon: Icons.WORKSPACES,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.workspace") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_workspace_no_matches"),
})

EmptyStates.set(MissingEntityType.ZONE_NOT_FOUND, {
  entityName: t("entity.zone"),
  icon: Icons.ZONES_SLASH,
  title: t("sfxEmpty.title_entity_not_found", { entity: t("entity.zone") }),
  subtitle: t("sfxEmpty.subtitle_entity_not_found", { entity: t("entity.zone") }),
  quote: t("sfxEmpty.quote_zone_not_found"),
})

EmptyStates.set(MissingEntityType.ZONE_NO_MATCHES, {
  entityName: t("entity.zone"),
  icon: Icons.ZONES_SLASH,
  title: t("sfxEmpty.title_entity_no_matches", { entity: t("entity.zone") }),
  subtitle: t("sfxEmpty.subtitle_entity_no_matches"),
  quote: t("sfxEmpty.quote_zone_no_matches"),
})

EmptyStates.set(MissingEntityType.NO_ISSUES_RAISED, {
  entityName: t("entity.issue"),
  title: t("sfxEmpty.title_no_issues_raised"),
  subtitle: t("sfxEmpty.subtitle_no_issues_raised"),
  quote: t("sfxEmpty.quote_no_issues_raised"),
})
